import { createSelector } from "selectors";
export { default as selectSelectedSectionUid } from "./selectSelectedSectionUid";

export const selectDragData = (state) => state.ui.dragData;

export const selectFloorplanDimens = (state) => state.ui.floorplanDimens;

export const selectOpenConversation = (state) => state.ui.openConversation;

export const selectReservationCreateUiVersion = (state) =>
  state.ui.reservationCreateUiVersion;

export const selectScrollToTime = (state) => state.ui.scrollToTime;

export const selectSelectedBusiness = (state) => state.ui.selectedBusiness;

export const selectSelectedDate = createSelector(
  (state) => state.ui.selectedDate,
  (date) => {
    if (!date) return new Date();
    if (typeof date === "string") return new Date(date);
    return date;
  }
);

export const selectShowInbox = (state) => state.ui.showInbox;

export const selectShowNotificationArchiveModal = (state) =>
  state.ui.showNotificationArchiveModal;

export const selectShowWaitTimesTable = (state) => state.ui.showWaitTimesTable;

export const selectTableLayoutMode = (state) => state.ui.listType;
